<template>
  <v-expansion-panel v-model="panel">
    <!-- Panel header -->
    <v-expansion-panel-header class="mt-2">
      Buscar lote
      <template v-slot:actions>
        <v-btn class="mr-5" @click.native.stop="reload()" icon small>
          <v-icon color="primary">mdi-reload</v-icon>
        </v-btn>
        <v-btn @click="$store.dispatch('deleteWindowByUuid', { uuid: win.uuid })" icon small>
          <v-icon color="error">mdi-close</v-icon>
        </v-btn>
      </template>
    </v-expansion-panel-header>
    <!-- Panel content -->
    <v-expansion-panel-content>
      <v-card>
        <Block v-if="isLoading"></Block>
        <!-- Tabs -->
        <v-tabs v-model="tab" dark background-color="primary" icons-and-text>
          <v-tabs-slider color="red"></v-tabs-slider>
          <v-tab href="#tab-1">
            Lista de lotes
            <v-icon>mdi-map-search</v-icon>
          </v-tab>
        </v-tabs>
        <!-- Tabs content -->
        <v-tabs-items v-model="tab" touchless>
          <v-tab-item value="tab-1">
            <v-card color="white" flat class="pa-1 position-relative">
              <!-- Search panel -->
              <v-row class="py-3">
                <v-col class="d-flex justify-end">
                  <div class="d-flex">
                    <v-text-field 
                      v-model="searchText"
                      prepend-icon="mdi-magnify"
                      placeholder="Buscar..." 
                      class="mr-1 f-flex align-center"
                      style="width: 100%; width: 350px;"
                      hide-details
                      outlined
                      dense
                      @keydown.enter.prevent="search"
                    />
                    <Button prepend-icon="mdi-magnify" @click="search()">
                      Buscar
                    </Button>
                  </div>
                </v-col>
              </v-row>
              <!-- Lots table -->
              <RealStateLotsTable 
                :lots="lots" 
                :services="services"
                :customers="customers"
                :sellers="sellers"
                :sale-types="saleTypes"
                :reservation-types="reservationTypes"
                @row-selected="(row) => selectedLot = row"
              />
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-expansion-panel-content>

    <v-dialog 
      v-model="showLotForm" 
      @close="selectedLot = null"
      @click:outside="selectedLot = null"
      max-width="1000px"
      max-height="90vh"
      scrollable
    >
      <RealStateLotForm 
        v-if="selectedLot" 
        :lot-data="selectedLot"
        @lot-updated="reload"
        @lot-deleted="reload"
        @close="selectedLot = null"
      />
    </v-dialog>

    <Alert
      v-model="alert.show"
      :type="alert.type"
      :title="alert.title"
      :message="alert.message"
      @input="alert.onInputEvent"
      @action="alert.onActionEvent"
    />
  </v-expansion-panel>
</template>

<script>
import {mapState} from 'vuex';
import Block from '@/components/Block.vue';
import Alert from '@/components/Alert.vue';
import RealStateLotsTable from './RealStateLotsTable.vue';
import Button from '@/components/Button.vue'
import RealStateLotForm from './RealStateLotForm.vue';

export default {
  name: 'RealStateLotsList',
  components: {
    Block,
    RealStateLotsTable,
    RealStateLotForm,
    Alert,
    Button,
  },
  props:['win'],
  data() {
    return {
      isLoading: false,
      panel: 0,
      tab: null,
      lots: [],
      alert: {
        type: 'success',
        show: false,
        header: '',
        body: '',
        onInputEvent: this.closeAlert,
        onActionEvent: this.closeAlert,
      },
      services: [],
      customers: [],
      sellers: [],
      saleTypes: [],
      reservationTypes: [],
      selectedLot: null,
      searchText: '',
    }
  },
  computed: {
    ...mapState(
      'rolesUser',
      {
        rolesStatus: (state) => state.roles,
      }
    ),
    showLotForm() {
      return !!this.selectedLot
    },
  },
  methods: {
    async loadLots() {
      try {
        const ID_Business = JSON.parse(localStorage.getItem("user")).businessid
        const ID_Branch = JSON.parse(localStorage.getItem("user")).branch

        const search = {
          ID_Business,
          ID_Branch,
          text: this.searchText,
        };

        const response = await this.$API.realstate.getLots({
          search
        });

        this.lots = response.data
      } catch(err) {
        console.log('Error', 'Ha ocurrido obteniendo la lista de lotes.', 'error')
        this.lots = [];
        // this.showAlert('Error', 'Ha ocurrido obteniendo la lista de lotes.', 'error');
      }
    },
    async loadServices() {
      try {
        const response = await this.$API.services.getAllServices({ noLimit: true });

        this.services = response;
      } catch(err) {
        this.showAlert('Error', 'Ha ocurrido obteniendo la lista de servicios.', 'error');
      }

      this.isLoading = false;
    },
    async loadCustomers() {
      try {
        const business = JSON.parse(localStorage.getItem("user")).businessid || ""
        const branch = JSON.parse(localStorage.getItem("user")).branch || ""

        const response = await this.$API.customers.getCustomers({
          business,
          branch
        })

        this.customers = response;
      } catch(err) {
        this.showAlert('Error', 'Ha ocurrido obteniendo la lista de clientes.', 'error');
      }
    },
    async loadSellers() {
      try {
        const response = await this.$API.sellers.getAllSellersFiltered();

        this.sellers = response;
      } catch(err) {
        this.showAlert('Error', 'Ha ocurrido obteniendo la lista de vendedores.', 'error');
      }
    },
    async loadSaleTypes() {
      try {
        const response = await this.$API.realstate.getSaleTypes();

        this.saleTypes = response;
      } catch(err) {
        this.showAlert('Error', 'Ha ocurrido obteniendo la lista de tipos de venta.', 'error');
      }
    },
    async loadReservationTypes() {
      this.isLoading = true;
      try {
        const response = await this.$API.realstate.getReservationTypes();

        this.reservationTypes = response;

      } catch(err) {
        this.showAlert('Error', 'Ha ocurrido obteniendo la lista de tipos de reserva.', 'error');
      }
    },
    showAlert(title, message, type = 'success', onInputEvent, onActionEvent) {
      this.alert.type = type;
      this.alert.title = title;
      this.alert.message = message;
      this.alert.show = true;
      this.alert.onInputEvent = onInputEvent 
        ? onInputEvent
        : this.closeAlert;
      this.alert.onActionEvent = onActionEvent 
        ? onActionEvent
        : this.closeAlert;
      
    },
    closeAlert() {
      this.alert.show = false;
    },
    async reload() {
      this.selectedLot = null;
      this.$store.dispatch('rolesUser/getAllRoles')
      this.isLoading = true
      try {
        await Promise.all([
          this.loadLots(),
          this.loadSaleTypes(),
          this.loadReservationTypes(),
          this.loadServices(),
          this.loadCustomers(),
          this.loadSellers(),
        ]);
      } catch (err) {
        console.log(err)
      }

      this.isLoading = false
    },
    search() {
      this.loadLots()
    }
  },
  mounted(){
    this.reload()
  }
}
</script>